<template>
  <div v-if="currentCreateMigrationStep > 1 && currentCreateMigrationStep < 4">
    <v-stepper
      v-if="$vuetify.breakpoint.smAndUp"
      :alt-label="$vuetify.breakpoint.sm"
      readonly
      class="transparent elevation-0"
      :value="currentCreateMigrationStep"
    >
      <v-stepper-header>
        <v-stepper-step
          step="1"
          :complete="currentCreateMigrationStep > 1"
          color="accent"
        >
          <div
            :class="[
              'd-flex text-center text-wrap normal-line-height',
              stepLabelClass(1),
            ]"
          >
            {{ $t("migrationCreationCSV.step1ProgressBar") }}
          </div>
        </v-stepper-step>

        <v-stepper-step
          step="2"
          :complete="currentCreateMigrationStep > 2"
          color="accent"
        >
          <div
            :class="[
              'd-flex text-center text-wrap normal-line-height',
              stepLabelClass(2),
            ]"
          >
            {{ $t("migrationCreationCSV.step2ProgressBar") }}
          </div>
        </v-stepper-step>

        <v-stepper-step
          step="3"
          :complete="currentCreateMigrationStep > 3"
          color="accent"
        >
          <div
            :class="[
              'd-flex text-center text-wrap normal-line-height',
              stepLabelClass(3),
            ]"
          >
            {{ $t("migrationCreationCSV.step3ProgressBar") }}
          </div>
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>

    <v-progress-linear
      background-color="grey lighten-2"
      color="accent"
      :value="progress"
      height="7"
      class="rounded-xl"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CreateMigrationProgressBar",

  computed: {
    ...mapGetters(["currentCreateMigrationStep", "createMigrationStepsNumber"]),

    progress() {
      return (
        (this.currentCreateMigrationStep * 100) /
        this.createMigrationStepsNumber
      );
    },
  },

  methods: {
    stepLabelClass(step) {
      if (this.currentCreateMigrationStep === step) {
        return "font-weight-bold orange--text text--darken-2";
      }
      if (this.currentCreateMigrationStep > step) {
        return "grey--text text--darken-1 font-weight-regular";
      }
      return "grey--text text--darken-1 font-weight-regular";
    },
  },
};
</script>
